<template>
    <div class="d-flex wrapper">
     <button class="btn btn-outline-primary">{{buttonName}}
         <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" fill="currentColor" class="bi bi-caret-down-fill" viewBox="0 0 16 16">
            <path stroke="currentColor" stroke-width="1" d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z"/>
          </svg>
     </button>
    </div>
</template>


<script>
export default {
    props:["buttonName"]
}
</script>


<style lang="scss" scoped>
    button{
        height: 36px;
        width: auto;
        font-size:14px;
        // border: 1px solid #007bff;
        position: relative;
        // bottom: 2px;
        background:transparent;
        // color:#007bff !important;
    }
        
    .icon-wrapper{
            position: relative;
            bottom: 2px;
            border: 1px solid #007bff;
            border-inline-start: 0px;
            border-radius: 4px;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            background:transparent;
        svg{
            position: relative;
            top: 6px;
            inset-inline-end:3px;
            color:#fff !important;
        }
    }
</style>